module.exports = __webpack_public_path__ + "media/kate_i_am_times_new_roman.5ff26cbd.mp3";